import { render, staticRenderFns } from "./ProcessModifyResponsible.vue?vue&type=template&id=4386fcc8"
import script from "./ProcessModifyResponsible.vue?vue&type=script&lang=js"
export * from "./ProcessModifyResponsible.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports